import { Navigate, useLocation } from 'react-router-dom'
import { destinoDoLegado } from './legado'

/** `/backoffice/...` de antes das áreas leva ao endereço novo, com busca, âncora e
 *  `state`. O atalho de uma pendência e o filtro de um link do Dashboard vivem na
 *  busca, e a volta do contrato para a Frente vive no `state`. */
export function LegacyBackofficeRedirect() {
  const { pathname, search, hash, state } = useLocation()
  return <Navigate to={destinoDoLegado(pathname, search, hash) ?? '/'} replace state={state} />
}
